export const researchFacilities = [
  {
    title: "Research Facilities",
    desc: "Dedicated R&D zones for development, optimization and analytical support.",
  },
  {
    title: "Innovation",
    desc: "Continuous improvements in route efficiency, yield and purity.",
  },
  {
    title: "Development Process",
    desc: "From feasibility to scale-up with controlled experiments and documentation.",
  },
  {
    title: "Laboratory Excellence",
    desc: "Method development & robust analytical capability to meet quality goals.",
  },
]

